// Helper para gerar slug do artista igual ao backend
export function slugifyArtist(name) {
  if (!name) return "";
  let s = name.toLowerCase().trim();
  const accents = {
    "á": "a", "à": "a", "ã": "a", "â": "a", "ä": "a",
    "é": "e", "ê": "e", "è": "e", "ë": "e",
    "í": "i", "ï": "i", "ì": "i", "î": "i",
    "ó": "o", "õ": "o", "ô": "o", "ò": "o", "ö": "o",
    "ú": "u", "ü": "u", "ù": "u", "û": "u",
    "ç": "c", "ñ": "n",
  };
  for (const [k, v] of Object.entries(accents)) {
    s = s.replaceAll(k, v);
  }
  s = s.replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");
  return s.slice(0, 80) || "artista";
}
